/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect } from 'react';
import IEnergyManagementProps from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import useMounted from '../../../shared/useMount/useMount';
import useConnectorAndDynamicProps from '../../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import PortfolioCarbonAvoidanceWidget from './PortfolioCarbonAvoidanceWidget';
import CarbonAvoidanceSummaryWidget from './CarbonAvoidanceSummaryWidget';
import { formattedDate } from '../../../shared/Utils/Utils';

const getConnectorConfigCarbon = () => {
    return {
        name: 'portfolio-carbon-avoidance',
        options: {
            startDate: '',
            endDate: ''
        }
    };
};

const PortfolioCarbonAvoidanceTabComponet = (
    props: IEnergyManagementProps
) => {
    const { bearerToken, requestContext } = props;
    const isMounted = useMounted();

    useEffect(() => {
        if (isMounted) {
            dataConnector && dataConnector.actions && dataConnector.actions.getAll();
        }
    }, [requestContext]);

    const connectorConfig = getConnectorConfigCarbon();
    connectorConfig.options.startDate = formattedDate(requestContext.context.startTime ?? '');
    connectorConfig.options.endDate = formattedDate(requestContext.context.endTime ?? '');

    const [dataConnector] = useConnectorAndDynamicProps({
        connectorConfig,
        requestContext,
        bearerToken
    });

    return (
        <div>
            <PortfolioCarbonAvoidanceWidget dataConnector={dataConnector} />
            <CarbonAvoidanceSummaryWidget bearerToken={bearerToken ?? 'bearer '} requestContext={requestContext} />
        </div>
    );
};
export default PortfolioCarbonAvoidanceTabComponet;
